import { MODULE_CLAIM } from '../../users/_constants/module-claim';
import { useHasPermission as useHP } from '../../users/_hooks/use-has-permission';
import type { RoleClaim } from '../../users/_types/role-claim';

interface UseHasPermissionProps {
  roles: RoleClaim[];
}

export function useHasPermission({ roles }: UseHasPermissionProps) {
  return useHP({ module: MODULE_CLAIM.rules, roles });
}
